import React, { useEffect, useState } from "react";
import YhInput from "../../../../../ui/YhInput";
import YhSelect from "../../../../../ui/YhSelect";
import YhButton from "../../../../../ui/YhButton";
import {
  isTruthy,
  openErrorNotification,
  openSuccessNotification,
} from "../../../../../helpers/methods";
import notifiers from "../../../../../global/constants/NotificationConstants";
import customErrorHandler from "../../../../../utils/customErrorHandler";
import CustomLoader from "../../../../../global/components/CustomLoader/CustomLoader";
import { validateInput } from "./Validation";
import { getAllUsers } from "./PersonalDetailsService";
import { updateExportDetails } from "../StepperService";
import {
  getAllSource,
  getAllStage,
  getAllTeam,
} from "../../ShowAll/ShowAllService";
import { useStepper } from "../../exportLead/StepperContext";

interface CustomProps {
  nextStep?: () => void | undefined;
  userId: String;
  setUserId?: Function;
  fromSettingOrLogout?: any;
  addNewTeamDialog: any;
  eventForEdit: any;
  handleCloseAddTeam: Function;
  registerStepActions?: (actions: { submit: () => void | Promise<void> }) => void;
  hideFooterButtons?: boolean;
}

const PersonalDetails = (props: CustomProps) => {
  const [personalDetailState, setPersonalDetailState] = useState<any>({});
  const [apiResponse, setApiResponse] = useState(false);
  const [state, setState] = useState<any[]>([]);
  const [formName, setFormName] = useState<any[]>([]);
  const { updateStepperProps } = useStepper();

  useEffect(() => {
    if (props.addNewTeamDialog?.edit) {
      tabelDataForEdit();
    }
    tableDataShowHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const tabelDataForEdit = () => {
    setPersonalDetailState((prevFormData: any) => ({
      ...prevFormData,
      formId: {
        error: "",
        value: props.eventForEdit.form_name,
        id: props.eventForEdit.formId,
      },
      data: [props.eventForEdit],
      leadPhone: props.eventForEdit.leadPhone,
      leadEmail: props.eventForEdit.leadEmail,
      leadName: props.eventForEdit.leadName,
      id: props.eventForEdit._id,
      source: props.eventForEdit._id,
    }));
  };

  const handleOnChangeInputField = (event: any) => {
    const name: any = event.target.name;
    const value: any = event.target.value;
    const isGoForward: any = validateInput(name, value);
    if (!isGoForward) return;
    setPersonalDetailState((prevFormData: any) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleFormChange = (event: any) => {
    const selectedId = event.target.value;
    const selected = formName.find((f: any) => String(f.id) === String(selectedId));
    if (!selected) return;

    setPersonalDetailState((prevFormData: any) => ({
      ...prevFormData,
      formId: {
        error: "",
        value: selected.label,
        id: selected.id,
      },
      data: state.filter((e: any) => selected.id == e._id),
    }));
  };

  const tableDataShowHandler = async () => {
    try {
      setApiResponse(true);
      await getAllTeam();
      await getAllStage();
      await getAllSource();

      const response = await getAllUsers();
      setState(response.data.map((e: any) => e));
      setFormName(
        response.data.map((i: any) => ({
          id: i._id,
          label: i.form_name,
        }))
      );
    } catch (error: any) {
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    } finally {
      setApiResponse(false);
    }
  };

  const submitForm = async () => {
    if (!(personalDetailState?.formId?.id && personalDetailState?.fileName)) {
      openErrorNotification("Please select a form and enter a file name");
      return;
    }

    try {
      const body = {
        upload_file_name: personalDetailState.fileName,
        formId: personalDetailState.formId.id,
      };
      updateStepperProps({
        ...personalDetailState,
        fileName: personalDetailState.fileName,
      });
      const response = await updateExportDetails(body);
      if (response?.success) {
        openSuccessNotification(response?.message);
        updateStepperProps({ uploadLeadId: response?.data?._id });
        props.nextStep?.();
      } else {
        customErrorHandler(response);
      }
    } catch (error: any) {
      openErrorNotification(
        isTruthy(error?.message) ? error?.message : notifiers.GENERIC_ERROR
      );
    }
  };

  useEffect(() => {
    props.registerStepActions?.({ submit: submitForm });
  });

  const formOptions = formName.map((f: any) => ({
    label: f.label,
    value: f.id,
  }));

  const selectedForm = personalDetailState?.data?.[0];

  return (
    <div className="flex flex-col gap-5">
      <div>
        <h2 className="text-lg font-semibold text-[#111827]">Lead Details</h2>
        <p className="mt-1 text-sm text-[#6B7280]">
          Choose the form and name this upload.
        </p>
      </div>

      <div className="grid max-w-3xl gap-4 sm:grid-cols-2">
        <YhSelect
          label="Form Name"
          placeholder="Select your form name"
          value={personalDetailState?.formId?.id || ""}
          onChange={handleFormChange}
          options={formOptions}
          error={personalDetailState?.formId?.error || ""}
        />
      </div>

      {personalDetailState?.formId?.id ? (
        <div className="grid max-w-3xl gap-4 border-t border-[#EEF0F5] pt-5 sm:grid-cols-2">
          {[
            { label: "Developer Name", value: selectedForm?.developer_name },
            { label: "Project Name", value: selectedForm?.project_name },
            { label: "Property Type", value: selectedForm?.projecttype_name },
          ].map((item) => (
            <div key={item.label}>
              <p className="yh-label">{item.label}</p>
              <p className="rounded-yh-md border border-[#EEF0F5] bg-[#F8FAFC] px-3 py-2.5 text-sm text-[#374151]">
                {item.value || "—"}
              </p>
            </div>
          ))}
          <YhInput
            label="File Name"
            placeholder="Enter Name"
            value={personalDetailState?.fileName || ""}
            onChange={handleOnChangeInputField}
            name="fileName"
            type="text"
          />
        </div>
      ) : null}

      {!props.hideFooterButtons && (
        <div className="mt-2 flex justify-end">
          <YhButton variant="primary" size="sm" onClick={submitForm}>
            Save & Continue
          </YhButton>
        </div>
      )}

      {apiResponse && <CustomLoader apiResponse={apiResponse} />}
    </div>
  );
};

export default PersonalDetails;
